import React from 'react';
import { Typography } from 'antd';
import { EditOutlined, SendOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface Props {
  name: string | null;
  telegramUsername: string | null;
  onEditName?: () => void;
}

export const ProfileHeader: React.FC<Props> = ({ name, telegramUsername, onEditName }) => {
  const { t } = useTranslation('customer');
  const displayName = name ?? t('profile.fallbackName');
  return (
    <div style={{
      margin: '12px 16px 0',
      borderRadius: 'var(--bl-radius-lg)',
      background: 'var(--bl-surface)',
      border: '1px solid var(--bl-divider)',
      padding: '16px 16px',
      display: 'flex',
      alignItems: 'center',
      gap: 14,
    }}>
      {/* Initials circle */}
      <div style={{
        width: 52, height: 52, borderRadius: 'var(--bl-radius-lg)', flexShrink: 0,
        background: 'rgba(51,144,236,0.10)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 17, fontWeight: 600,
        color: 'var(--bl-primary)',
        letterSpacing: -1,
      }}>
        {displayName[0]?.toUpperCase() ?? '?'}
      </div>

      {/* Text */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <Typography.Text style={{
          display: 'block',
          fontSize: 17, fontWeight: 600,
          color: 'var(--bl-text)',
          letterSpacing: -0.4,
          lineHeight: 1.25,
        }}>
          {displayName}
        </Typography.Text>
        {telegramUsername && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginTop: 3 }}>
            <SendOutlined style={{ fontSize: 11, color: 'var(--bl-primary)' }} />
            <Typography.Text style={{ fontSize: 13, color: 'var(--bl-primary)', fontWeight: 500 }}>
              @{telegramUsername.replace(/^@/, '')}
            </Typography.Text>
          </div>
        )}
      </div>

      {onEditName && (
        <button
          type="button"
          aria-label={t('profile.header.editName')}
          onClick={onEditName}
          style={{
            flexShrink: 0,
            width: 44,
            height: 44,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 'none',
            background: 'transparent',
            color: 'var(--bl-text-secondary)',
            fontSize: 18,
            cursor: 'pointer',
            padding: 0,
            borderRadius: 'var(--bl-radius-md)',
          }}
        >
          <EditOutlined />
        </button>
      )}
    </div>
  );
};
